/**
 * Created by vladislav on 9/6/2022
 */

const AndroidBase = function (name, options) {
    Platform.call(this, name, options);

    connector.info.os = connector.OS_ANDROID;
    connector.social.needWindowForLogin = true;

    this.needsCountry = true;
};

AndroidBase.prototype = Object.create(Platform.prototype);
AndroidBase.prototype.constructor = AndroidBase;

AndroidBase.prototype._callNative = function (method, options) {
    AndroidNative.callNative(method, JSON.stringify(options));
};

AndroidBase.prototype.checkLatestVersion = function (callback) {
    this.callNative("AppUpdatePlugin.checkLatestVersion", undefined, (code, response) => {
        if (code !== connector.CODE_SUCCEED || response && response.error) {
            this.bus.trigger("stream:error", `AndroidBase.checkLatestVersion ${JSON.stringify(response && response.error)}`);
            callback(connector.CODE_FAILED);
            return;
        }

        callback(connector.CODE_SUCCEED, response);
    });
};

AndroidBase.prototype._initialize = function (callback) {
    new ConnectorActionPlayer([
        (f) => {
            let attempt = 0;

            const waitAndroidNative = () => {
                if (typeof AndroidNative !== "undefined" && typeof AndroidNative.callNative === "function") {
                    f();
                    return;
                }

                setTimeout(waitAndroidNative, 100);

                attempt++;
                if (attempt === 60) {
                    this.bus.trigger("stream:error", "Wait AndroidNative 6 sec");
                }
            };

            waitAndroidNative();
        },

        (f) => {
            this.callNative("AndroidPlatformPlugin.getAppSettings", (code, settings) => {
                connector.info.language = settings.defaultLanguage;

                connector.info.deviceName = settings.deviceName;
                connector.info.deviceVersion = settings.deviceVersion;
                if (settings.idfa && !settings.idfa.startsWith("0000")) {
                    connector.info.deviceID = settings.idfa;
                }

                connector.info.audioPluginAvailable = settings.audioPluginAvailable;
                connector.info.isGoogleTestDevice = Boolean(settings.isGoogleTestDevice);

                this.setSafePadding(settings.safePadding);

                connector.platform.subscribeNative("AndroidPlatformPlugin", (event, options) => this.onNativeEvent(event, options));

                f();
            });
        },

        (f) => {
            connector.dataLoader.localStorage = new WebViewLocalStorage();
            f();
        }
    ]).play(callback);
};

AndroidBase.prototype._parsePayload = function (callback) {
    if (!this.oneOf(connector.ANDROID, connector.AMAZON)) {
        callback();
        return;
    }

    if (this.attributionInitialized) {
        callback(this.attribution);
        return;
    }

    this.callNative("AdjustPlugin.getAttribution", (code, attribution) => {
        this.setAttribution(code === connector.CODE_SUCCEED ? attribution : undefined);
        callback(this.attribution);
    });
};

AndroidBase.prototype.setAttribution = function (attribution) {
    if (attribution) {
        attribution.channel = attribution.channel || attribution.campaign || "";
    }

    this.attribution = attribution;
    this.attributionInitialized = true;
};

AndroidBase.prototype.closeApplication = function () {
    connector.platform.callNative("AndroidPlatformPlugin.closeApplication");
};

AndroidBase.prototype.hasVibration = function () {
    return true;
};

AndroidBase.prototype.vibrate = function (options) {
    connector.platform.callNative("AndroidPlatformPlugin.vibrate", options);
};

AndroidBase.prototype.getSafePadding = function () {
    return this.safePadding;
};

AndroidBase.prototype.onNativeEvent = function (event, options) {
    console.log(`AndroidPlatformPlugin.onNativeEvent - ${event}`);

    switch (event) {
        case "onUpdateSafePadding":
            this.setSafePadding(options.safePadding);
            break;
        case "onBackButtonPressed":
            this.bus.trigger("backButtonPressed");
            break;
        case "onAttributionChanged":
            this.setAttribution(options.attribution);
            this.bus.trigger("attributionChanged", this.attribution);
            break;
    }
};
